<div class="menu" (click)="menuClicked($event)">

    <!-- Main menu -->
    <div class="main-menu">
        <perfect-scrollbar
            class="scroll"
            [config]="{ suppressScrollX: true }">

            <ul class="list-unstyled">

                <li
                    *ngFor="let item of menuItems"
                    [ngClass]="{
                        'active':
                            (
                                selectedParentMenu === item.to &&
                                viewingParentMenu === ''
                            ) ||
                            viewingParentMenu === item.to
                    }">

                    <!-- Main-menu external link -->
                    <a
                        *ngIf="item.newWindow"
                        [href]="item.to"
                        rel="noopener noreferrer"
                        target="_blank">

                        <i
                            *ngIf="item.src === ''; else mainExternalImage"
                            [ngClass]="item.icon">
                        </i>

                        <ng-template #mainExternalImage>
                            <img
                                class="svg-icon w-25"
                                [src]="item.src"
                                alt="image is loading">
                        </ng-template>

                        {{ item.label | translate }}
                    </a>

                    <!-- Main-menu item that has a submenu -->
                    <a
                        *ngIf="
                            !item.newWindow &&
                            item.subs &&
                            item.subs.length > 0
                        "
                        [href]="item.to"
                        (click)="openSubMenu($event, item); false">

                        <i
                            *ngIf="item.src === ''; else mainSubmenuImage"
                            [ngClass]="item.icon">
                        </i>

                        <ng-template #mainSubmenuImage>
                            <img
                                class="svg-icon w-25"
                                [src]="item.src"
                                alt="image is loading">
                        </ng-template>

                        {{ item.label | translate }}
                    </a>

                    <!-- Main-menu item that has no submenu -->
                    <a
                        *ngIf="
                            !item.newWindow &&
                            (
                                !item.subs ||
                                item.subs.length === 0
                            )
                        "
                        [routerLink]="item.to"
                        (click)="
                            changeSelectedParentHasNoSubmenu(item.to);
                            false
                        ">

                        <i
                            *ngIf="item.src === ''; else mainRouteImage"
                            [ngClass]="item.icon">
                        </i>

                        <ng-template #mainRouteImage>
                            <img
                                class="svg-icon w-25"
                                [src]="item.src"
                                alt="image is loading">
                        </ng-template>

                        {{ item.label | translate }}
                    </a>

                </li>

            </ul>

        </perfect-scrollbar>
    </div>

    <!--
        Do not put an *ngIf on this element.

        The Vien global menu classes control both the submenu visibility
        and the amount of space reserved for it.
    -->
    <div class="sub-menu">

        <perfect-scrollbar
            class="scroll"
            [config]="{ suppressScrollX: true }">

            <ul
                *ngFor="let item of menuItems"
                class="list-unstyled"
                [attr.data-parent]="item.to"
                [ngClass]="{
                    'd-block':
                        (
                            selectedParentMenu === item.to &&
                            viewingParentMenu === ''
                        ) ||
                        viewingParentMenu === item.to
                }">

                <li
                    *ngFor="let sub of item.subs"
                    [ngClass]="{
                        'active': currentUrl === sub.to,
                        'has-sub-item':
                            sub.subs &&
                            sub.subs.length > 0
                    }">

                    <!-- Submenu external link -->
                    <a
                        *ngIf="sub.newWindow"
                        [href]="sub.to"
                        rel="noopener noreferrer"
                        target="_blank"
                        (click)="closeSubMenu($event)">

                        <i
                            *ngIf="
                                sub.icon !== '';
                                else submenuExternalImage
                            "
                            [ngClass]="sub.icon">
                        </i>

                        <ng-template #submenuExternalImage>
                            <img
                                class="subMenuImg"
                                [src]="sub.src"
                                alt="image is loading">
                        </ng-template>

                        <span class="d-inline-block">
                            {{ sub.label | translate }}
                        </span>
                    </a>

                    <!--
                        Normal submenu route.

                        This includes Analytics.
                    -->
                    <a
                        *ngIf="
                            !sub.newWindow &&
                            (
                                !sub.subs ||
                                sub.subs.length <= 0
                            )
                        "
                        href="javascript:void(0)"
                        routerLinkActive="active"
                        (click)="
                            navigateAndCloseSubMenu(
                                $event,
                                sub.to
                            )
                        ">

                        <i
                            *ngIf="
                                sub.icon !== '';
                                else submenuRouteImage
                            "
                            [ngClass]="sub.icon">
                        </i>

                        <ng-template #submenuRouteImage>
                            <img
                                class="subMenuImg"
                                [src]="sub.src"
                                alt="image is loading">
                        </ng-template>

                        <span class="d-inline-block">
                            {{ sub.label | translate }}
                        </span>
                    </a>

                    <!-- Submenu item that contains deeper items -->
                    <a
                        *ngIf="
                            sub.subs &&
                            sub.subs.length > 0
                        "
                        (click)="toggleCollapse(sub.to)"
                        [ngClass]="{
                            'rotate-arrow-icon opacity-50 c-pointer': true,
                            'collapsed':
                                closedCollapseList.includes(sub.to)
                        }">

                        <i class="simple-icon-arrow-down"></i>

                        <span class="d-inline-block">
                            {{ sub.label | translate }}
                        </span>
                    </a>

                    <!-- Deep submenu -->
                    <div
                        *ngIf="
                            sub.subs &&
                            sub.subs.length > 0
                        "
                        [collapse]="
                            closedCollapseList.includes(sub.to)
                        "
                        [isAnimated]="true">

                        <ul class="list-unstyled inner-level-menu">

                            <li
                                *ngFor="let deepSub of sub.subs"
                                [ngClass]="{
                                    'active':
                                        currentUrl === deepSub.to
                                }">

                                <!-- Deep submenu external link -->
                                <a
                                    *ngIf="deepSub.newWindow"
                                    [href]="deepSub.to"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    (click)="closeSubMenu($event)">

                                    <i [ngClass]="deepSub.icon"></i>

                                    <span class="d-inline-block">
                                        {{ deepSub.label | translate }}
                                    </span>
                                </a>

                                <!-- Deep submenu internal route -->
                                <a
                                    *ngIf="
                                        !deepSub.newWindow &&
                                        (
                                            !deepSub.subs ||
                                            deepSub.subs.length <= 0
                                        )
                                    "
                                    href="javascript:void(0)"
                                    routerLinkActive="active"
                                    (click)="
                                        navigateAndCloseSubMenu(
                                            $event,
                                            deepSub.to
                                        )
                                    ">

                                    <i [ngClass]="deepSub.icon"></i>

                                    <span class="d-inline-block">
                                        {{ deepSub.label | translate }}
                                    </span>
                                </a>

                            </li>

                        </ul>

                    </div>

                </li>

            </ul>

        </perfect-scrollbar>
    </div>

</div>